module.exports = __webpack_public_path__ + "img/announce_character.9def15fa.png";